import { Link } from "react-router-dom"
import { formatDate, getUserPermission } from "../services/helpers"


const userPermission = getUserPermission();

export function ServiceTile({service, onDeleteClick, onPaymentClick}){

	return <div className="info-tile">

		<div className="primary-info-section">
			<strong className="capitalize">{service.ticket_type} Ticket</strong> <span className={`status-card ${service.status?.replaceAll(" ","-")}`}>{service.status}</span>
				<Link to={`/dashboard/vehicles/${service.license_plate}/services`}><b> {service.license_plate}</b></Link>
				<p>{service.vehicle_name}</p>
				<p>Total Invoice: <strong >GHS</strong> <span className={service.total_paid < service.total_invoice ? "red-text" : "blue-text"}>{service.total_paid}</span> <strong>/{service.total_invoice ?? 0}</strong></p>

		</div>

		<div className="secondary-info-section">
			<Link to={`/dashboard/members/u/${service.uuid ?? service.customer_id}/vehicles`}><b>{service.customer_name}</b></Link>
			<p>Service Date: {formatDate(service.date_created)}</p>
			<p>Last Updated: {formatDate(service.date_updated)}</p>
		</div>
		<div className="action-section col">
			<Link className="" to={service.ticket_type === "service" ? `/dashboard/services/${service.license_plate}/${service.ticket_id}` : `/dashboard/members/u/${service.customer_id}/${service.ticket_id}`}>Details </Link>
			{onPaymentClick && <button className="link" onClick={onPaymentClick}>Record Payment </button>}
			{userPermission === "admin" && onDeleteClick != null &&  <button className="link red-text"  onClick={onDeleteClick}>Delete Service Ticket </button>}
		</div>
	</div>
}


